export default "__VITE_ASSET__CWrnl5jE__"